import '@/assets/styles/common.less';
import Vue from 'vue';
import Cookies from 'js-cookie';
import WechatPlugin from 'vux/src/plugins/wechat';
// 处理vux全局引用打包过大问题
import Flexbox from 'vux/src/components/flexbox/flexbox.vue';
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue';
import Divider from 'vux/src/components/divider/index.vue';
import TransferDom from 'vux/src/directives/transfer-dom/index.js';
import Flow from 'vux/src/components/flow/flow.vue';
import FlowLine from 'vux/src/components/flow/flow-line.vue';
import FlowState from 'vux/src/components/flow/flow-state.vue';
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js';
import LoadingPlugin from 'vux/src/plugins/loading/index.js';
import ToastPlugin from 'vux/src/plugins/toast/index.js';
import { _province } from './assets/js/province.js';
import { _city } from './assets/js/citys.js';


import App from './App.vue';
import router from './router';
import store from './store';
import api from './api';



let env = 'prod';
if (location.hostname.indexOf('test') > -1 || location.hostname === 'localhost') {
    env = 'test';
} else if (location.hostname.indexOf('demo') > -1) {
    env = 'demo';
}
window.UCUnified.init({
    env,
    systemCode: 'g7s',
    appid: 'g7s_szyl_h5',
    enableUCLoginPolling: true,
    dstSystemUrl: encodeURIComponent(`${location.origin}/app/archive-wxmobile/#/login/load`),
});



Vue.prototype.$api = api;
Vue.config.productionTip = false;
Vue.component('flexbox', Flexbox);
Vue.component('flexbox-item', FlexboxItem);
Vue.component('divider', Divider);
Vue.component('flow', Flow);
Vue.component('flow-state', FlowState);
Vue.component('flow-line', FlowLine);
Vue.directive('transfer-dom', TransferDom);
Vue.use(LoadingPlugin);
Vue.use(ConfirmPlugin);
Vue.use(ToastPlugin, { position: 'middle' });
Vue.use(WechatPlugin);
window._province = _province;
window._city = _city;


const render = () => {
    new Vue({
        router,
        store,
        render: h => h(App),
    }).$mount('#app');
};

window.UCUnified.checkUCLogin({
    onSuccess: (data) => {
        // 数字运力H5线上为http环境，所以由自己设置
        const { new_token, domain } = data || {};
        if (new_token) {
            Cookies.set('UC_TOKEN_GLOBAL', new_token, { domain });
        }
        render();
    },
    onFail: () => {
        // 判断如果不是 /login/load 页面，则跳转到平台用户中心
        if (!location.hash.includes('#/login/load')) {
            window.UCUnified.openUCLogin();
            return;
        }
        render();
    },
    onError: () => {
        render();
    },
});


